export const dataPasswords: {
  id: "oldPwd" | "newPwd" | "confirmaPwd",
  placeholder: string,
}[] = [
  { id: "oldPwd", placeholder: "Old password" },
  { id: "newPwd", placeholder: "New password" },
  { id: "confirmaPwd", placeholder: "Confirm new password" },
];
